import * as yup from 'yup';

yup.addMethod(yup.string, 'confirmNewPassword', function () {
  return this.test('confirmNewPassword', function () {
    const { path, createError } = this;
    const fieldConfirmPassword = document.getElementsByName(path)[0];
    const fieldPassword = document.getElementsByName('newPassword')[0];
    return new Promise((resolve, reject) => {
      if (
        fieldConfirmPassword &&
        fieldPassword &&
        fieldConfirmPassword.value === fieldPassword.value
      ) {
        resolve(true);
      } else {
        reject(
          createError({
            path,
            message: 'passwords not match ',
            type: 'confirmNewPassword'
          })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  currentPassword: yup
    .string()
    .min(8)
    .max(50)
    .required(),
  newPassword: yup
    .string()
    .min(8)
    .max(50)
    .required(),
  confirmNewPassword: yup
    .string()
    .confirmNewPassword()
    .min(8)
    .max(50)
    .required()
});

export default schema;
